<template>
    <vue-good-table class="col-12 top-24"
        :columns="columns"
        :rows="contracts"
        :pagination-options="{
            enabled: true,
            perPage: 25
        }"
        :search-options="{
            enabled: true
        }"
    >
        <template #table-actions>

            <download-excel
                class="btn-primary"
                style="padding-top: 1px;
                       padding-bottom: 1px;
                       margin-right: 5px;
                       margin-top: 2px;"
                :data="contracts"

                worksheet="My Worksheet"
                name="filename.xls"
            >
                Экспорт
            </download-excel>
        </template>
    </vue-good-table>
</template>

<script>
    import 'vue-good-table-next/dist/vue-good-table-next.css'
    import { VueGoodTable } from 'vue-good-table-next';
    import JsonExcel from "vue-json-excel3";
    import moment from 'moment'

  export default {
    components: { VueGoodTable, downloadExcel:JsonExcel, },
    props: {
        contracts: {
            type: Array,
            required: true
        }
    },
    data() {
      return {
        columns: [
            {
                label: 'Наименование договора',
                field: 'ContractName',
            },
            {
                label: 'Номер',
                field: 'ContractID',
                type: 'number',
            },
            {
                label: 'Контрагент',
                field: 'CompanyName',
            },
            {
                label: 'ИНН контрагента',
                field: 'CompanyINN',
            },
            {
                label: 'Адрес',
                field: 'CompanyAddress',
            },
            {
                label: 'Дата начала действия',
                field: this.fieldStartDate,

            },
            {
                label: 'Дата окончания действия',
                field: this.fieldFinishDate

            },
        ]
      }
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        // Contracts() {
        //     return this.$store.state.eco_contracts
        // },
    },
    methods: {
        format_date(value, time='NaN'){
            if (value) {
                if (time !== 'NaN') {
                return moment(String(value)).format('DD.MM.YYYY')
                } else {
                return moment(String(value)).format('DD.MM.YYYY HH:mm')
                }
            }
        },
        fieldStartDate(rowObj) {
            return this.format_date(rowObj['ContractDateStart'])
        },
        fieldFinishDate(rowObj) {
            return this.format_date(rowObj['ContractDateFinish'])
        }
    }
  };
</script>
